//
//
//
//
//
//

import {
  SPINNER_VARIANT_DEFAULT,
  SPINNER_VARIANT_WHITE,
} from '../../utils/constants'
export default {
  props: {
    size: {
      type: Number,
      default: 8,
      validator(val) {
        return val >= 2 && val <= 12 && !(val % 1)
      },
    },
    weight: {
      type: Number,
      default: 4,
      validator(val) {
        return val >= 2 && val <= 4 && !(val % 2)
      },
    },
    variant: {
      type: String,
      default: SPINNER_VARIANT_DEFAULT,
      validator(val) {
        return [SPINNER_VARIANT_DEFAULT, SPINNER_VARIANT_WHITE].includes(val)
      },
    },
  },
  computed: {
    spinnerClass() {
      const size = {
        2: 'tw-h-2 tw-w-2',
        3: 'tw-h-3 tw-w-3',
        4: 'tw-h-4 tw-w-4',
        5: 'tw-h-5 tw-w-5',
        6: 'tw-h-6 tw-w-6',
        7: 'tw-h-7 tw-w-7',
        8: 'tw-h-8 tw-w-8',
        9: 'tw-h-9 tw-w-9',
        10: 'tw-h-10 tw-w-10',
        11: 'tw-h-11 tw-w-11',
        12: 'tw-h-12 tw-w-12',
      }
      const weight = {
        2: 'tw-border-2',
        4: 'tw-border-4',
      }
      return [
        size[this.size],
        weight[this.weight],
        this.variant === SPINNER_VARIANT_WHITE
          ? 'tw-border-white'
          : 'tw-border-gray-800',
        'tw-border-t-transparent',
      ]
    },
  },
}
